import { connect } from 'react-redux'
import { modalActions } from 'store/modal'
import AudioDataDownload from '../components/AudioDataDownload'
import { fetchSites } from '../../../../Sites/routes/SitesPage/modules/Sites'
import {
  actions as ptpsActions,
  fetchSelectionPtps,
  downloadAudioData,
} from '../../../../Participants/routes/ParticipantsPage/modules/Participants'
import { downloadParticipantData } from '../../../../Participants/routes/CreateParticipant/modules/CreateParticipant'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { loading, participants, study, instruments } = state
  const { participants: _participants, participantSelectionList, checkedPtps } = participants

  return {
    checkedPtps,
    audioDownloadLoading: loading.audio,
    numTotalPtps: Object.keys(_participants).length,
    participantSelectionList,
    ptpSelectionListLoading: loading.selectionPtps,
    siteId: study.currentStudy.base_site_ids[0],
    studyId: study.currentStudy.id,
    instruments: instruments?.instrumentList || [],
    studyVersionID,
  }
}

const mapDispatchToProps = {
  downloadParticipantData,
  resetCheckedPtps: ptpsActions.resetCheckedPtps,
  fetchSites,
  fetchSelectionPtps,
  closeModal: modalActions.closeModal,
  togglePtp: ptpsActions.toggleFilterParticipant,
  togglePtpOn: ptpsActions.toggleFilterParticipantOn,
  togglePtpOff: ptpsActions.toggleFilterParticipantOff,
  downloadAudioData,
}

export default connect(mapStateToProps, mapDispatchToProps)(AudioDataDownload)
